// extracted by mini-css-extract-plugin
module.exports = {"MemberLink":"MemberLink_MemberLink__MizhQ","text":"MemberLink_text__2qdjC","icon":"MemberLink_icon__1geOx"};